/* eslint eslint-comments/no-use: off */
import {LABELS} from '../constants/labels'
import type {AddedToProjectV2EventFragment} from './AddedToProjectV2Event'
import {AddedToProjectV2sRendering} from './AddedToProjectV2Event'
import {type RemovedFromProjectV2EventFragment, RemovedFromProjectV2sRendering} from './RemovedFromProjectV2Event'

type RolledupProjectV2EventProps = {
  rollupGroup: Record<string, Array<AddedToProjectV2EventFragment | RemovedFromProjectV2EventFragment>>
}

export function RolledupProjectV2Event({rollupGroup}: RolledupProjectV2EventProps): React.ReactElement {
  const addedEvents = (rollupGroup['AddedToProjectV2Event'] as AddedToProjectV2EventFragment[]) || []
  const removedEvents = (rollupGroup['RemovedFromProjectV2Event'] as RemovedFromProjectV2EventFragment[]) || []

  return (
    <>
      <AddedToProjectV2sRendering queryRefs={addedEvents} />
      {addedEvents.length > 0 && removedEvents.length > 0 && ` ${LABELS.timeline.and} `}
      <RemovedFromProjectV2sRendering queryRefs={removedEvents} />
    </>
  )
}
